module.exports = __webpack_public_path__ + "static/media/CV.1dfcee82.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/CV.svg
// module id = 234
// module chunks = 0